import { payMCopyDateStatusInversed } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate';
import { TwinIconToolTip } from '../../../../../../../../baseComponents/TwinIcon';
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation';
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types';
import { faCircleInfo, faGear, faXmarkCircle } from '@fortawesome/pro-light-svg-icons';
import { PayMCopyDateLogTypeKeys } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate/payMCopyDateLog';
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans';
import { ButtonSecondary } from '../../../../../../../../baseComponents/Button';
import { displayDate } from '../../../../../../../../utils/globals/date';
import { SetEditPaymentMethodModalTy } from '../types';

interface HeaderModalEditPaymentMethodDateProps {
    full_assigned_number: string
    availableGroup: boolean
    setOpenModal: SetEditPaymentMethodModalTy
}

export const HeaderModalEditPaymentMethodDate: React.FC<HeaderModalEditPaymentMethodDateProps> = ({ setOpenModal, full_assigned_number, availableGroup }) => {
    return (
        <div className='flex items-center justify-between mb-25'>
            <h2><TwinTrans transKey='managePayments'>Gestionar pagos</TwinTrans> - {full_assigned_number}</h2>
            {availableGroup ? <ButtonSecondary onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpenModal({ type: 'group', allRowData: {} }) }}><TwinTrans transKey='toGroup'>Agrupar</TwinTrans></ButtonSecondary> : null}
        </div>
    )
}

interface RenderPaymentMethodDateLogsProps {
    allRowData: RowData
    setOpenModal: SetEditPaymentMethodModalTy
}

export const RenderPaymentMethodDateLogs: React.FC<RenderPaymentMethodDateLogsProps> = ({ allRowData, setOpenModal }) => {
    const { tVars } = useTwinTranslation()
    const log = allRowData?.PayMDateCopyLogs?.[0]
    const extraDataParsed = JSON.parse(log?.extraData || '{}')
    const options = { employeeTrigger: log?.EmployeeTrigger?.fullname_short || '', date: displayDate(new Date(log?.createdAt)), newDate: displayDate(new Date(extraDataParsed?.newDate)), fullAssignedNumber: extraDataParsed?.full_assigned_number || '', 'interpolation': { 'escapeValue': false }, }
    let message = ''
    const dictLogsMessages: Record<PayMCopyDateLogTypeKeys, string> = {
        1: tVars('createPaymentMethodDateMessage', '{{employeeTrigger}} creó este pago el {{date}}', options),
        2: tVars('changeStatusPaymentMethodDateMessage', '{{employeeTrigger}} cambió el estado de este pago el {{date}}', options),
        3: tVars('changeDatePaymentMethodDateMessage', '{{employeeTrigger}} cambió la fecha a {{newDate}} de este pago el {{date}}', options),
        4: tVars('changePaymentTypePaymentMethodDateMessage', '{{employeeTrigger}} cambió el tipo de pago el {{date}}', options),
        5: tVars('changeExtraPaymentDataPaymentMethodDateMessage', '{{employeeTrigger}} cambió la información de este pago el {{date}}', options),
        6: tVars('paymentMethodDateGroupedMessage', '{{employeeTrigger}} ha agrupado este pago el {{date}}', options),
        7: tVars('paymentMethodDateDividedMessage', '{{employeeTrigger}} ha dividido este pago el {{date}}', options)
    }
    message = dictLogsMessages?.[log?.type as PayMCopyDateLogTypeKeys]
    return (
        <TwinIconToolTip id={'info' + String(allRowData?.id)} message={message} icon={faCircleInfo} className='ml-auto' classNameIcon='w-18 h-18' onClick={() => setOpenModal({ type: 'showLogs', allRowData: {...allRowData, dictLogsMessages} || {} })} />
    )
}
interface ManagePaymentMethodDateIconProps {
    allRowData: RowData
    setOpenModal: SetEditPaymentMethodModalTy
}

export const ManagePaymentMethodDateIcon: React.FC<ManagePaymentMethodDateIconProps> = ({ allRowData, setOpenModal }) => {
    const { t } = useTwinTranslation()
    const notToBeIncluded = [payMCopyDateStatusInversed['divided'], payMCopyDateStatusInversed['grouped'], payMCopyDateStatusInversed['payed']]
    if (notToBeIncluded.includes(allRowData.status) ) {
        return null
    }
    return (
        <TwinIconToolTip id={'manage' + String(allRowData?.id)} message={t('managePayment', 'Gestionar pago')} icon={faGear} className='ml-auto' classNameIcon='w-18 h-18' onClick={() => setOpenModal({ type: 'manage', allRowData: allRowData || {} }) } />
    )
}

interface DeniedPaymentMethodDateIconProps {
    allRowData: RowData
    setOpenModal: SetEditPaymentMethodModalTy
}

export const DeniedPaymentMethodDateIcon: React.FC<DeniedPaymentMethodDateIconProps> = ({ allRowData, setOpenModal }) => {
    const { t } = useTwinTranslation()
    const notIncluded = [payMCopyDateStatusInversed['divided'], payMCopyDateStatusInversed['grouped'], payMCopyDateStatusInversed['denied']]

    if (notIncluded.includes(allRowData.status)) {
        return null
    }
    return (
        <TwinIconToolTip id={'denied' + String(allRowData?.id)} message={t('markAsUnpayed', 'Marcar como impagado')} icon={faXmarkCircle} className='ml-auto' classNameIcon='w-18 h-18 hover:text-red-BA' onClick={() =>  setOpenModal({ type: 'denied', allRowData: allRowData || {} }) } />
    )
}